export default "__VITE_ASSET__BTQqKt6e__"